module.exports = __webpack_public_path__ + "static/chrome-732bcfe1f6fed088e228b007a2b13705.svg";